export default "__VITE_ASSET__8yCj1uSS__"